import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  return <section className="bg-carbon overflow-hidden" data-id="element-203">
      {/* Logo bar */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="px-5 md:px-8 pt-6 md:pt-8 max-w-6xl mx-auto" data-id="element-204">
        <img src="https://cdn.magicpatterns.com/uploads/nZqkddm5E5UrbhfRn3ESPb/IMG_6635.jpg" alt="Doctor Ecommerce" className="h-10 md:h-12 w-auto" data-id="element-205" />
      </motion.div>

      {/* COVER IMAGE — Full-width salon photo */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="relative w-full mt-6 md:mt-8" data-id="element-206">
        <div className="relative w-full h-[280px] sm:h-[360px] md:h-[480px] lg:h-[560px] overflow-hidden" data-id="element-207">
          <img src="https://cdn.magicpatterns.com/uploads/6JETo78pdk7YQizb4udEkQ/heylloyd-image-1773456424863.png" alt="Salón de belleza profesional con estilistas atendiendo clientes" className="w-full h-full object-cover object-center" data-id="element-208" />
          <div className="absolute inset-0 bg-gradient-to-t from-carbon via-carbon/20 to-transparent" data-id="element-209" />
        </div>
      </motion.div>

      {/* Hero content below the image */}
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 -mt-16 md:-mt-20 pb-14 md:pb-20" data-id="element-210">
        <motion.div initial="hidden" animate="visible" variants={containerVariants} className="flex flex-col items-center text-center" data-id="element-211">
          <motion.h1 variants={itemVariants} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gold leading-[1.1] mb-6" data-id="element-212">
            ¿Tu silla vacía le está costando $500 al día a tu negocio?
          </motion.h1>

          <motion.p variants={itemVariants} className="text-base sm:text-lg md:text-xl text-gray-300 mb-8 md:mb-10 leading-relaxed max-w-2xl" data-id="element-213">
            Llenamos tu agenda de citas confirmadas con clientes que pagan el
            precio completo, no con buscadores de cupones de descuento que nunca
            vuelven.
          </motion.p>

          <motion.ul variants={containerVariants} className="space-y-3 md:space-y-4 mb-8 md:mb-10 text-left max-w-2xl w-full" data-id="element-214">
            <motion.li variants={itemVariants} className="flex items-start" data-id="element-215">
              <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald shrink-0 mr-3 mt-0.5" data-id="element-216" />
              <span className="text-gray-200 text-sm md:text-base lg:text-lg" data-id="element-217">
                Si tienes horas muertas entre citas aunque seas el mejor en tu
                zona
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start" data-id="element-218">
              <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald shrink-0 mr-3 mt-0.5" data-id="element-219" />
              <span className="text-gray-200 text-sm md:text-base lg:text-lg" data-id="element-220">
                Si para llenar la agenda tienes que publicar ofertas de 50% de
                descuento que solo atraen clientes de una sola vez
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start" data-id="element-221">
              <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald shrink-0 mr-3 mt-0.5" data-id="element-222" />
              <span className="text-gray-200 text-sm md:text-base lg:text-lg" data-id="element-223">
                Si tu Instagram tiene seguidores pero no se convierten en citas
                reales
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start" data-id="element-224">
              <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald shrink-0 mr-3 mt-0.5" data-id="element-225" />
              <span className="text-gray-200 text-sm md:text-base lg:text-lg" data-id="element-226">
                Si dependes del "boca a boca" para conseguir clientes nuevos
              </span>
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start" data-id="element-227">
              <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-emerald shrink-0 mr-3 mt-0.5" data-id="element-228" />
              <span className="text-gray-200 text-sm md:text-base lg:text-lg" data-id="element-229">
                Si tus estilistas están parados varias horas al día esperando
                clientes
              </span>
            </motion.li>
          </motion.ul>

          <motion.p variants={itemVariants} className="text-gold font-bold text-lg md:text-xl italic mb-8" data-id="element-230">
            Esto es para ti.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-231">
            <CTAButton scrollToId="contacto" className="w-full sm:w-auto text-base md:text-lg" data-id="element-232">
              QUIERO MI AGENDA LLENA ESTA SEMANA
            </CTAButton>
            <p className="text-gray-500 text-xs md:text-sm mt-3" data-id="element-233">
              Diagnóstico gratuito en 15 minutos.
            </p>
            <p className="text-gray-500 text-xs md:text-sm mt-2" data-id="element-234">
              ¿Prefieres agendar directamente?{' '}
              <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold underline underline-offset-2 hover:text-gold/80 transition-colors" data-id="element-235">
                Reserva en nuestro calendario →
              </a>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}